// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonIcon_button__5ekyh","cover":"ButtonIcon_cover__5Iqlm","rounded":"ButtonIcon_rounded__StViU"};